import { z } from "zod/v4";

export const pollTypeSchema = z.enum(["single_choice", "multiple_choice"]);

export const pollOptionSchema = z.object({
	id: z.string().uuid(),
	label: z.string(),
	sort_order: z.number().int(),
	vote_count: z.number().int(),
});

export const pollSchema = z.object({
	id: z.string().uuid(),
	club_id: z.string().uuid(),
	creator_id: z.string().uuid(),
	question: z.string(),
	poll_type: pollTypeSchema,
	is_anonymous: z.boolean(),
	is_closed: z.boolean(),
	closes_at: z.coerce.date().nullable().optional(),
	total_votes: z.number().int(),
	options: z.array(pollOptionSchema),
	my_votes: z.array(z.string()),
	created_at: z.coerce.date(),
});

export const createPollSchema = z.object({
	question: z.string().min(1, "Question is required"),
	poll_type: pollTypeSchema,
	options: z
		.array(z.string().min(1, "Option cannot be empty"))
		.min(2, "At least 2 options required"),
	is_anonymous: z.boolean().optional(),
	closes_at: z.string().nullable().optional(),
});

export const voteSchema = z.object({
	option_ids: z.array(z.string().uuid()).min(1, "Select at least one option"),
});
